<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script lang="ts" setup>
import DatePicker, {
  type DatePickerEmits,
  type DatePickerProps,
  type DatePickerSlots,
} from 'primevue/datePicker'

interface Props extends /* @vue-ignore */ Omit<DatePickerProps, 'size'> {
  modelValue: Date | Date[] | (Date | null)[] | null
  error?: boolean
  dateFormat?: string
  view?: 'date' | 'month' | 'year' | undefined
  placeholder?: string
  minDate?: Date
  maxDate?: Date
  selectionMode?: 'single' | 'multiple' | 'range'
  numberOfMonths?: 1 | 2
  disabled?: boolean
  manualInput?: boolean
  sufix?: { IconClass?: string } | { text: string }
}

const props = withDefaults(defineProps<Props>(), {
  manualInput: true,
  dateFormat: 'dd/mm/yy',
  view: undefined,
  placeholder: undefined,
  minDate: undefined,
  maxDate: undefined,
  selectionMode: 'single',
  numberOfMonths: 1,
  sufix: undefined,
})

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ DatePickerEmits {}
defineEmits<Emits>()

const model = defineModel<Props['modelValue'] | null>()
const slots = defineSlots<Exclude<DatePickerSlots, object>>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))

const _placeholder = computed(() => {
  if (props.placeholder) return props.placeholder
  if (props.selectionMode === 'range') return 'DD/MM/AAAA - DD/MM/AAAA'
  return 'DD/MM/AAAA'
})
</script>

<template>
  <InputAddon
    :prefix="{ IconClass: 'icon-[ph--calendar-blank-bold]' }"
    :sufix
  >
    <DatePicker
      v-bind="$props"
      v-model="model"
      :date-format
      :size="$viewport.isLessThan('md') ? 'small' : undefined"
      :invalid="errorInjected || error"
      :placeholder="_placeholder"
      :manual-input
    >
      <template
        v-for="(_, slot) in slots"
        #[slot]="slotData"
      >
        <slot
          :name="slot"
          v-bind="slotData"
        />
      </template>
    </DatePicker>
  </InputAddon>
</template>
